import * as FlagIcons   from 'country-flag-icons/react/3x2';
import { AllCountries } from '@widesk-ui/tools/countries';

export default function getFlagFromCountryCode(countryCode: CountryCode) {
	const FlagComponent = FlagIcons[countryCode];

	return (
		<FlagComponent
			style={{ border: `1px solid lightgray`, borderRadius: 2, height: 'auto', width: 20 }}
			title={AllCountries[countryCode]}
		/>
	);
}